import "./index.css";
import { ClosedAdminTabs } from "./components/Tabs/ClosedAdminTabs";
import { OpenAdminTabs } from "./components/Tabs/OpenAdminTabs";
import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import salesIcon from "../../assets/admin-dash/tabs-icons/sales-icon-admin.svg";
import mgmtIcon from "../../assets/admin-dash/tabs-icons/mgmt-icon-admin.svg";
import hrIcon from "../../assets/admin-dash/tabs-icons/hr-icon-admin.svg";
import marketingIcon from "../../assets/admin-dash/tabs-icons/marketing-icon-admin.svg";
import designIcon from "../../assets/admin-dash/tabs-icons/design-icon-admin.svg";
import productionIcon from "../../assets/admin-dash/tabs-icons/production-icon-admin.svg";
import logisticsIcon from "../../assets/admin-dash/tabs-icons/logistics-icon-admin.svg";
import commsIcon from "../../assets/admin-dash/tabs-icons/comms-icon-admin.svg";
import timePlanningIcon from "../../assets/admin-dash/tabs-icons/time-planning-icon-admin.svg";
import businessPartnerIcon from "../../assets/admin-dash/tabs-icons/business-partner-icon-admin.svg";

const queryClient = new QueryClient();

const AdminDash = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState("");
  const handleClick = (name) => {
    setOpen(name);
  };
  const tabs = [
    { id: 1, name: t("SALES"), nickname: t("SALES"), icon: salesIcon },
    { id: 2, name: t("MANAGEMENT"), nickname: t("MGMT"), icon: mgmtIcon },
    { id: 3, name: t("HR"), nickname: t("HR"), icon: hrIcon },
    {
      id: 4,
      name: t("MARKETING"),
      nickname: t("MARKETING"),
      icon: marketingIcon,
    },
    { id: 5, name: t("DESIGN"), nickname: t("DESIGN"), icon: designIcon },
    {
      id: 6,
      name: t("PRODUCTION"),
      nickname: t("PRODUCTION"),
      icon: productionIcon,
    },
    {
      id: 7,
      name: t("LOGISTICS"),
      nickname: t("LOGISTICS"),
      icon: logisticsIcon,
    },
    { id: 8, name: t("COMMUNICATIONS"), nickname: t("COMMS"), icon: commsIcon },
    {
      id: 9,
      name: t("TIME_PLANNING"),
      nickname: t("TIME_PLANNING"),
      icon: timePlanningIcon,
    },
    {
      id: 10,
      name: t("BUSINESS_PARTNER"),
      nickname: t("BUSINESS_PARTNER"),
      icon: businessPartnerIcon,
    },
  ];

  const renderTabContent = () => {
    switch (open) {
      case t("SALES"):
        return (
          <div className="tab-content-placeholder">
            <p>Sales content coming soon...</p>
          </div>
        );
      case t("MGMT"):
        return (
          <div className="tab-content-placeholder">
            <p>Management content coming soon...</p>
          </div>
        );
      case t("HR"):
        return (
          <div className="tab-content-placeholder">
            <p>HR content coming soon...</p>
          </div>
        );
      case t("MARKETING"):
        return (
          <div className="tab-content-placeholder">
            <p>Marketing content coming soon...</p>
          </div>
        );
      case t("DESIGN"):
        return (
          <div className="tab-content-placeholder">
            <p>Design content coming soon...</p>
          </div>
        );
      case t("PRODUCTION"):
        return (
          <div className="tab-content-placeholder">
            <p>Production content coming soon...</p>
          </div>
        );
      case t("LOGISTICS"):
        return (
          <div className="tab-content-placeholder">
            <p>Logistics content coming soon...</p>
          </div>
        );
      case t("COMMS"):
        return (
          <div className="tab-content-placeholder">
            <p>Communications content coming soon...</p>
          </div>
        );
      case t("TIME_PLANNING"):
        return (
          <div className="tab-content-placeholder">
            <p>Time & Planning content coming soon...</p>
          </div>
        );
      case t("BUSINESS_PARTNER"):
        return (
          <div className="tab-content-placeholder">
            <p>Business Partner content coming soon...</p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="admin-dash-container">
      <div className="admin-tabs-container ">
        {tabs.map((item) => {
          return open === item.nickname ? (
            <OpenAdminTabs
              name={item.nickname}
              key={item.id}
              onClick={() => handleClick("")}
              icon={item.icon}
            />
          ) : (
            <ClosedAdminTabs
              name={item.nickname}
              key={item.id}
              onClick={() => handleClick(item.nickname)}
            />
          );
        })}
      </div>
      {open && <div className="admin-tab-content">{renderTabContent()}</div>}
    </div>
  );
};

export default AdminDash;
